import { render } from "./Tips.vue?vue&type=template&id=07f7c098&scoped=true"
import script from "./Tips.vue?vue&type=script&lang=js"
export * from "./Tips.vue?vue&type=script&lang=js"

import "./Tips.vue?vue&type=style&index=0&id=07f7c098&lang=less&scoped=true"

import exportComponent from "/Users/kk/ulu/dev/UstoreWebPayPC/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f7c098"]])

export default __exports__